import { useEffect, useMemo, useState } from 'react';
import { employeeInvitationGateway, type InvitationState } from './EmployeeInvitationGateway';

/**
 * The invitation state of the given employees (the visible page). Identity owns invitations, so this is a separate read.
 * A refused or failed read (for example a role that may not see invitations) just means "no invitation shown": the list
 * never guesses a Pending Invite, and the resend action never appears without a real pending state.
 */
export function useEmployeeInvitationStates(employeeIds: readonly string[], reloadKey = 0) {
  const [states, setStates] = useState<Record<string, InvitationState>>({});
  const key = useMemo(() => employeeIds.join('|'), [employeeIds]);

  useEffect(() => {
    if (key === '') return;
    const controller = new AbortController();
    employeeInvitationGateway
      .listStates(key.split('|'), controller.signal)
      .then((next) => { if (!controller.signal.aborted) setStates((prev) => ({ ...prev, ...next })); })
      .catch(() => undefined);
    return () => controller.abort();
  }, [key, reloadKey]);

  return states;
}
